import dynamic from "next/dynamic";
const LogosAndHeaderSecurityComponent = dynamic(()=>import("./logos-and-header-security-component"));
import LogosAndHeaderSecurityConfig from "./logos-and-header-security-config";
import LogosAndHeaderSecurityAdvancedConfig from "./logos-and-header-security-advanced-config";
export default {
    LogosAndHeaderSecurityComponent,
    LogosAndHeaderSecurityConfig,
    LogosAndHeaderSecurityAdvancedConfig
};
